import LongShineFormItem from '@/pages/Alarm/Create/components/AlarmChannelFormItem/LongShineChannelForm';
import TripartiteServerAlarmChannelForm from '@/pages/Alarm/Create/components/AlarmChannelFormItem/TripartiteServerAlarmChannelForm';
import { AlarmChannel } from '@/shared/types';
import { ComponentType } from 'react';

export const alarmRuleFormItemsByChannel: Partial<Record<AlarmChannel, ComponentType>> = {
  [AlarmChannel.LONGSHINE]: LongShineFormItem,
  [AlarmChannel.THIRD]: TripartiteServerAlarmChannelForm,
};
